import { render, staticRenderFns } from "./scoreManage.vue?vue&type=template&id=64597566&scoped=true&"
import script from "./scoreManage.vue?vue&type=script&lang=ts&"
export * from "./scoreManage.vue?vue&type=script&lang=ts&"
import style0 from "./scoreManage.vue?vue&type=style&index=0&id=64597566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64597566",
  null
  
)

export default component.exports